import angular from 'angular';
import uiRouter from 'angular-ui-router';

import appComponent from './app.component';
import admin from './admin/admin.module';
import account from './account/account.module';
import adverseEvent from './adverse-event/adverse-event.module';
import adverseEvents from './adverse-events/adverse-events.module';
import appCommon from './common/common.module';
import dashboard from './dashboard/dashboard.module';
import product from './product/product.module';
import treatProduct from './product/treat-product.module';
import products from './products/products.module';
import reports from './reports/reports.module';

export default angular.module('components.app', [
  uiRouter,
  admin,
  account,
  adverseEvent,
  adverseEvents,
  appCommon,
  dashboard,
  product,
  treatProduct,
  products,
  reports
])
  .component('app', appComponent)
  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state('app', {
        redirectTo: 'dashboard',
        url: '/app',
        // data: {
        //   permissions: {
        //     except: ['ANONYMOUS'],
        //     redirectTo: 'login'
        //   }
        // },
        resolve: {
          flex: () => '100',
          layout: () => 'column',
          currentUser: SessionService => SessionService.user
        },
        component: 'app'
      });
  })
  .name;



// WEBPACK FOOTER //
// ./components/app/app.module.js